



































import {
  Vue,
  Component,
} from "@/shared/vuepack";

@Component
export default class HowItWorksSteps extends Vue {
}
